export default __webpack_public_path__ + "static/media/center.8e5b3bdf.png";